<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
export default {
  page: {
    meta: [
      {
        name: "description"
      },
    ],
  },
  components: {
   Layout,
    PageHeader,
    // ReportsHeader,
  },
  data() {
    return {
      limit: 20,
      page: 1,
      tot_pages:0,
    //   selectedCurrency:{},
    //   customers: [],
    //   matchedCurrencies: [],
      transactions: [],
    //   currencies: [],
      accountingPeriods: [],
      accountFilter: {
        accounting_period_id: null,
        from: "",
        to: "",
      },
      search: "",
      totalCredit: 0,
      totalDebit: 0,
      index: 1,
    //   selectedCustomer: "",
      items: [],
      content: [],
      balance:0,
      show_all_transactions:[]
    };
  },
  methods: {
    getAgentReport(page) {
      console.log({ accountFilter: this.accountFilter });
      this.http
          .post("billing-invoices/electricity-report", {
            // id: this.selectedCustomer.id,
            // currency_id:this.selectedCurrency.id,
            accountFilter: this.accountFilter,
            page,
            limit:this.limit
          })
          .then((res) => {
            this.transactions = res.data;
            if(res.status && res.data.length==0){
              this.popup.alert({
                title: "popups.error",
                msg: this.$t("reports.no_data")
              });
            }
            else if (res.status) {
              console.log(res.data);
              this.tot_pages = Math.ceil(res.tot / this.limit);
              this.page=page
              this.totalCredit = 0;
              this.totalDebit = 0;
              this.balance= res.balance
              this.transactions.forEach((transaction) => {
                if (transaction.type == "credit") {
                  this.totalCredit += parseFloat(transaction?.value);
                } else {
                  this.totalDebit += parseFloat(transaction?.value);
                }
              });
            }
          });
    },
    // selectCustomer() {
    //   console.log("this.selectedCustomer",this.selectedCustomer);
    //   this.http
    //       .post("sales-agents/select-customer", {
    //         id: this.selectedCustomer.id,
    //       })
    //       .then((res) => {
    //         if (res.status) {
    //           this.currencies = res.currencies;
    //           console.log(res);
    //         }
    //       });
    // },
    // showLabel(agent){
    //   return this.$i18n.locale == "ar"
    //       ? `${agent?.code} ${agent?.name}`
    //       : `${agent?.code} ${agent?.name}`;
    // },
    // searchCustomers(search) {
    //   this.http
    //       .post("sales-agents/search", { search })
    //       .then((res) => {
    //         if (res.status) {
    //           this.customers = res.data
    //         }
    //       });
    // },
  
    getAccountingPeriods() {
      this.http.get("accounting-peroids").then((resp) => {
        if (resp) {
          this.accountingPeriods = resp.data;
        }
      });
    },
    // searchCurrency(search) {
    //   this.matchedCurrencies = this.customer_currencies.filter(currency => currency?.name.toLowerCase().includes(search.toLowerCase()) || currency?.name_en.toLowerCase().includes(search.toLowerCase() ))
    // },
    // showCurrencyLabel(currency){
    //   return this.$i18n.locale=='ar' ? currency?.name : currency?.name_en
    // },
    // getCurrencies() {
    //   this.http.get("currencies/active").then((res) => {
    //     if (res.status) {
    //       this.currencies = res.data;
    //       console.log("Step 125 :",this.customer_currencies);
    //       this.selectedCurrency = this.customer_currencies[0]

    //     }
    //   });
    // },
    // getCustomer() {
    //   this.http.get("users/"+this.selectedCustomer.id).then((res) => {
    //     if (res.status) {
    //       this.selectedCustomer = res.data; 
    //           this.getCurrencies();
    //           // this.selectedCurrency =

    //           console.log("Step 138 ",this.selectedCustomer);

    //     }
    //   });
    // },
       printAll(){
       this.http
        .post("billing-invoices/electricity-report", {
        //   id: this.selectedCustomer.id,
            // currency_id:this.selectedCurrency.id,
            accountFilter: this.accountFilter,
            page:1
        })
           .then((res) => {
             if(res.status && res.data.length==0){
               this.popup.alert({
                 title: "popups.error",
                msg: this.$t("reports.no_data")
              });
            }
            else if (res.status) {
              this.show_all_transactions = res.data;
              console.log('comone may man', res.data);
              this.tot_pages = Math.ceil(res.tot / this.limit);
              this.totalCredit = 0;
              this.totalDebit = 0;
              this.balance= res.balance
              this.show_all_transactions.forEach((transaction) => {
                if (transaction.type == "credit") {
                  this.totalCredit += parseFloat(transaction?.value);
                } else {
                  this.totalDebit += parseFloat(transaction?.value);
                }
              });

  setTimeout(() => {
    
    this.$store.dispatch('utils/printElement', {
               orientation: 'p',
               elementId: 'custReport-all',
             }).then(()=>{
       this.show_all_transactions =[]
       this.totalCredit = 0;
     this.totalDebit = 0;
       this.transactions=[]
       }
       )
  }, 200);
            }
          });
    },
  },
//   computed: {
//     customer_currencies(){
//       if(this.selectedCustomer?.currency_id == this.currencies?.find(c=>c.is_functional)?.id){
//         return [this.currencies?.find(c=>c.is_functional)]
//       }
//       else if(this.selectedCustomer){
//         return [this.currencies?.find(c=>c.is_functional),this.currencies?.find(c=>c.id==this.selectedCustomer.currency_id)]
//       }
//       else{
//         return []
//       }
//     },

//   },
  created() {
    this.getAccountingPeriods();
  },
//   mounted(){
//     // this.selectedCustomer.id = this.$route.params.id
//     // this.selectedCurrency.id =1
//     this.getCustomer()
//   },
  watch: {
    // selectedCustomer() {
    //     console.log('ahmed', this.selectedCustomer)
    // }
  }
};
</script>

<template>
    <Layout>
      <div>{{ transactions.length }}</div>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.billing.subItems.account_statmetnt_electrircty')"
    /> 
    <div class="row">
      <div class="card">
        <div class="card-body">
          <form @submit.prevent="getAgentReport(1)">
            <div class="p-3" style="background-color: rgb(246, 247, 248)">
              <div class="row">
                <!-- customer -->
                <!-- <AutoComplete
                      v-model="selectedCustomer"
                      :complete-on-focus="true"
                      :suggestions="items"
                      @complete="searchAutoCop"
                      optionLabel="label"
                      style="color: #333 !important; border-radius: 10px !important;width:100%"
                  /> -->
                <!-- currency -->
                <!-- <div class="col-12 col-md-4">
                  <label
                      class="col-md-2.5 col-form-label"
                      for="userName"
                  >{{$t("purchases.currency")}}</label
                  >
                  <AutoComplete
                      v-model="selectedCurrency"
                      :complete-on-focus="true"
                      :suggestions="matchedCurrencies"
                      @complete="searchCurrency($event.query)"

                      :optionLabel="showCurrencyLabel"
                      style="color: #333 !important; border-radius: 10px !important;width:100%"
                  />
                </div> -->
              </div>
              <div class="row mt-2">
                <div class="col d-inline">
                  <label for="" class="d-block">{{
                      $t("report.period")
                    }}</label>

                  <select
                      v-model="accountFilter.accounting_period_id"
                      class="form-select"
                      >
                      <!-- :disabled="!selectedCustomer.id" -->
                    <option
                        :value="period.id"
                        v-for="period in accountingPeriods"
                        :key="period"
                    >
                      {{
                        period?.start_date +
                        ` ${this.$i18n.locale == "ar" ? "الى" : "To"} ` +
                        period?.end_date
                      }}
                    </option>
                  </select>
                </div>
                <div class="col d-inline">
                  <label for="" class="d-block">{{ $t("report.from") }}</label>
                  <input
                      v-model="accountFilter.from"
                      type="date"
                      class="form-control"
                      />
                      <!-- :disabled="!selectedCustomer.id" -->
                </div>
                <div class="col d-inline">
                  <label for="" class="d-block">{{ $t("report.to") }}</label>

                  <!-- :disabled="!selectedCustomer.id" -->
                  <input
                      v-model="accountFilter.to"
                      type="date"
                      class="form-control"
                  />
                </div>
                <div class="col d-flex align-items-end">
                    <!-- :disabled="!selectedCustomer.id" -->
                  <button
                    :disabled="!accountFilter.accounting_period_id"
                      style="height: 40px"
                      class="btn btn-success"
                  >
                    {{ $t("popups.search") }}
                  </button>
                </div>

              </div>
            </div>
          </form>

          <div v-if="transactions.length > 0">
            <br />
            <button class="mx-2 btn btn-success float-end" @click="this.$store.dispatch('utils/printElement',{elementId :'custReport',orientation:'p'})">
              <i class="bx bx-printer"></i>
            </button>
            <button class="btn btn-primary float-end" @click="printAll()">
              <i class="bx bx-printer"></i> {{ $t("report.print_all") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div  class="row mt-4" v-if="transactions.length > 0">
      <div id="custReport" class="card card-body" style="padding:20px">

        <!-- +selectedCustomer?.name -->
        <ReportsHeader
            :reportName="$t('reports.customers_statement')+' - '"
            :accountName="transactions[0]?.name"
            :filterdPeriod="accountFilter"
        />
        <div class="my-2">
          <h6 class="fw-bold">
            {{ $t("customers_report.balance") }} :&nbsp;
            <span class="">
              {{0 > parseFloat(balance) ? "(":""}}
              <!-- {{ processCurrency(selectedCurrency,Math.abs(balance),true) }} -->
              {{ parseFloat(Math.abs(balance)).toLocaleString() }}
              {{0 > balance ? ")":""}}
            </span>
          </h6>
        </div>
      
        <div class="table-responsive">
          <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
              :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
          >
            <thead>
            <tr
                class="text-light"
                style="background-color: #2a3042 !important"
            >
              <!-- <th scope="col">{{ $t("general_ledger.account_id") }}</th> -->
              <th scope="col">{{ $t("customers_report.date") }}</th>
              <!-- <th scope="col">{{ $t("customers_report.particular") }}</th> -->
              <th scope="col">{{ $t("customers_report.descr") }}</th>
              <th scope="col">{{ $t("customers_report.refrence_no") }}</th>
              <th scope="col">{{ $t("customers_report.debit") }}</th>
              <th scope="col">{{ $t("customers_report.credit") }}</th>
              <th scope="col">{{ $t("customers_report.balance") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                class=""
                v-for="transaction in transactions"
                :key="transaction"
            >
              <!-- <td>{{ transaction.code }}</td> -->
              <!-- <td>{{ transaction.name }}</td> -->
              <td>{{ transaction?.created.split("T")[0] }}</td>
              
              <td>
                {{
                  $i18n.locale == "ar"
                      ? transaction?.descr
                      : transaction?.descr_en
                }}
              </td>
              <td>
                {{ transaction.reference_no ? transaction.reference_no : '-' }}
              </td>
              <!-- <td>
                {{
                  transaction?.type == "debit"
                      ? processCurrency(selectedCurrency,transaction?.value,true)
                      : ""
                }}
              </td> -->
              <td>
                {{
                  transaction?.type == "debit"
                      ? parseFloat(transaction?.value).toLocaleString()
                      : ""
                }}
              </td>
              <!-- <td>
                {{
                  transaction?.type == "credit"
                      ? processCurrency(selectedCurrency,transaction?.value,true)
                      : ""
                }}
              </td> -->
              <td>
                {{
                  transaction?.type == "credit"
                      ? parseFloat(transaction?.value).toLocaleString()
                      : ""
                }}
              </td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <!-- <td class="total-style">
                {{ processCurrency(selectedCurrency,totalDebit,true) }}
              </td> -->
              <td class="total-style">
                {{ parseFloat(totalDebit).toLocaleString() }}
              </td>
              <!-- <td class="total-style">
                {{ processCurrency(selectedCurrency,totalCredit,true) }}
              </td> -->
              <td class="total-style">
                {{ parseFloat(totalCredit).toLocaleString() }}
              </td>
              <!-- <td class="total-style">
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? "(":""}}
                {{
                  
                     processCurrency(selectedCurrency, parseFloat(totalDebit) - parseFloat(totalCredit),true)
                  
                }}
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? ")":""}}

              </td> -->
              <td class="total-style">
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? "(":""}}
                {{
                  
                     (parseFloat(Math.abs(totalDebit - totalCredit))).toLocaleString()
                  
                }}
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? ")":""}}

              </td>
            </tr>
            </tbody>
          </table>
          <table>
            <thead>
            <th>{{ $t("reports.report_date") }} :</th>
            <th>
              {{
                `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()},
                 ${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}`
                }}
            </th>
            </thead>
          </table>
        </div>

        <ul class="pagination pagination-rounded justify-content-center mt-2 no-print">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getAgentReport(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getAgentReport(p)"
          >{{ p }}</a
        >
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getAgentReport(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
      </div>
    </div>



    <div  class="row mt-4" >
      <div id="custReport-all" class="card card-body print" style="padding:20px">

        <!-- +selectedCustomer?.name -->
        <ReportsHeader
            :reportName="$t('reports.customers_statement')+' - '"
            :accountName="transactions[0]?.name"
            :filterdPeriod="accountFilter"
        />
  <div class="my-2">
          <h6 class="fw-bold">
            {{ $t("customers_report.balance") }} :&nbsp;
            <!-- <span class="">
              {{0 > balance ? "(":""}}
              {{ processCurrency(selectedCurrency,Math.abs(balance),true) }}
              {{0 > balance ? ")":""}}
            </span> -->
            <span class="">
              {{0 > balance ? "(":""}}
              {{ parseFloat(Math.abs(balance)).toLocaleString() }}
              {{0 > balance ? ")":""}}
            </span>
          </h6>
        </div>
      
        <div class="table-responsive">
          <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
              :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
          >
            <thead>
            <tr
                class="text-light"
                style="background-color: #2a3042 !important"
            >
              <!-- <th scope="col">{{ $t("general_ledger.account_id") }}</th> -->
              <th scope="col">{{ $t("customers_report.date") }}</th>
              <!-- <th scope="col">{{ $t("customers_report.particular") }}</th> -->
              <th scope="col">{{ $t("customers_report.descr") }}</th>
              <th scope="col">{{ $t("customers_report.refrence_no") }}</th>
              <th scope="col">{{ $t("customers_report.debit") }}</th>
              <th scope="col">{{ $t("customers_report.credit") }}</th>
              <th scope="col">{{ $t("customers_report.balance") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                class=""
                v-for="transaction in show_all_transactions"
                :key="transaction"
            >
              <!-- <td>{{ transaction.code }}</td> -->
              <!-- <td>{{ transaction.name }}</td> -->
              <td>{{ transaction?.created.split("T")[0]  }} </td>
              <td>
                {{
                  $i18n.locale == "ar"
                      ? transaction?.descr
                      : transaction?.descr_en
                }}
              </td>
              <td>
                {{ transaction.reference_no ? transaction.reference_no : '-' }}
              </td>
              <!-- <td>
                {{
                  transaction?.type == "debit"
                      ? processCurrency(selectedCurrency,transaction?.value,true)
                      : ""
                }}
              </td> -->
              <td>
                {{
                  transaction?.type == "debit"
                      ? parseFloat(transaction?.value).toLocaleString()
                      : ""
                }}
              </td>
              <!-- <td>
                {{
                  transaction?.type == "credit"
                      ? processCurrency(selectedCurrency,transaction?.value,true)
                      : ""
                }}
              </td> -->
              <td>
                {{
                  transaction?.type == "credit"
                      ? parseFloat(transaction?.value).toLocaleString()
                      : ""
                }}
              </td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <!-- <td class="total-style">
                {{ processCurrency(selectedCurrency,totalDebit,true) }}
              </td> -->
              <td class="total-style">
                {{ parseFloat(totalDebit).toLocaleString() }}
              </td>
              <!-- <td class="total-style">
                {{ processCurrency(selectedCurrency,totalCredit,true) }}
              </td> -->
              <td class="total-style">
                {{ parseFloat(totalCredit).toLocaleString() }}
              </td>
              <!-- <td class="total-style">
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? "(":""}}
                {{
                  
                     processCurrency(selectedCurrency, parseFloat(totalDebit) - parseFloat(totalCredit),true)
                  
                }}
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? ")":""}}

              </td> -->
              <td class="total-style">
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? "(":""}}
                {{
                  
                     (parseFloat(totalDebit) - parseFloat(totalCredit)).toLocaleString()
                  
                }}
                {{0 > (parseFloat(totalDebit) - parseFloat(totalCredit)) ? ")":""}}

              </td>
            </tr>
            </tbody>
          </table>
          <table>
            <thead>
            <th>{{ $t("reports.report_date") }} :</th>
            <th>
              {{
                `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()},
                 ${String(new Date().getHours()).padStart(2, '0')}:${String(new Date().getMinutes()).padStart(2, '0')}`
                }}
            </th>
            </thead>
          </table>
        </div>

        <ul class="pagination pagination-rounded justify-content-center mt-2 no-print">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getAgentReport(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getAgentReport(p)"
          >{{ p }}</a
        >
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="getAgentReport(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
      </div>
    </div>
  <!-- </Layout> -->

  </Layout>
</template>

<style scoped>
/*
.table,
td {
  border: 1px solid black;
}
*/
.print {
  display: none;
}
@media print {
  .no-print {
    display: none;
  }
  .print {
    display: block;
  }
}
</style>
